import React from "react";


const TPRMresults = () => {
  document.title = "tprm-results";

  return (
    <React.Fragment>
      <div className="page-content">

        <h1>tprm-results</h1>
        
      </div>
    </React.Fragment>
  );
};

export default TPRMresults;
